import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const skippedRecordsState = (state: RootState) => state.scene.dashboard.skippedRecordsState;

export const getSkippedRecordsDrillDownViewStates = createSelector(
  skippedRecordsState,
  ({ viewStates }) => viewStates
);

export const getSkippedRecordsDrillDownTotalFilteredRecords = createSelector(
  skippedRecordsState,
  ({ totalFilteredRecords }) => totalFilteredRecords
);

export const getSkippedRecordsDrillDownTotalRecords = createSelector(
  skippedRecordsState,
  ({ totalRecords }) => totalRecords
);

export const getSkippedRecordsDrillDownConfiguration = createSelector(
  skippedRecordsState,
  ({ configuration }) => configuration
);

export const getSkippedRecordsDrillDownSpansBack = createSelector(
  skippedRecordsState,
  ({ spansBack }) => spansBack
);

export const isSkippedRecordsDrillDownLoading = createSelector(
  skippedRecordsState,
  ({ loading }) => loading
);
